import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./views/Home";
import Complete from "./views/Complete";
import Abort from "./views/Abort";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/complete",
        name: "Complete",
        component: Complete,
    },
    {
        path: "/abort",
        name: "Abort",
        component: Abort,
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;